<template>
  <div class="module-info">
    <!-- 服务权限 -->
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="auto"
      class="demo-ruleForm"
      size="small"
    >
      <el-form-item :label="$t('pages.operate.text49')" prop="platformProperty">
        <el-radio-group
          v-model="ruleForm.platformProperty"
          @change="appcodeChange"
        >
          <el-radio :label="1">{{ $t("pages.operate.text50") }}</el-radio>
          <el-radio :label="0">{{ $t("pages.operate.text51") }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="APP Code" prop="appCode">
        <el-select v-model="ruleForm.appCode" :placeholder="$t('public.text5')">
          <el-option
            v-for="item in optionA"
            :key="item.id"
            :label="item.codeName"
            :value="item.appCode"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('pages.operate.text52')" prop="bikeCategoryId">
        <el-checkbox-group v-model="ruleForm.bikeCategoryId">
          <el-checkbox
            :label="item.id"
            v-for="(item, index) in typeOptions"
            :key="index"
            >{{ item.name }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <div class="inputs">
        <el-form-item :label="$t('pages.operate.text53')" prop="maxConnections">
          <el-input-number
            @change="handleChange"
            v-model="ruleForm.maxConnections"
            :step="1"
            :min="ruleForm.maxConnections"
            :max="999999999"
            step-strictly
            v-if="!unlimited"
          ></el-input-number>
        </el-form-item>
        <el-checkbox
          :label="$t('omission.text13')"
          v-model="unlimited"
          @change="maxConnectionsChange"
          class="inputs-checkout"
        ></el-checkbox>
      </div>
      <div class="inputs">
        <el-form-item :label="$t('pages.operate.text54')" prop="serveStartTime">
          <el-date-picker
            v-model="ruleForm.serveStartTime"
            type="datetime"
            :placeholder="$t('public.text2')"
            @change="startChange"
            :picker-options="pickerOptions0"
          >
          </el-date-picker>
        </el-form-item>
        <span style="margin: 14px; margin-top: 0">-</span>
        <el-form-item label-width="0" prop="serveStopTime">
          <el-date-picker
            v-model="ruleForm.serveStopTime"
            type="datetime"
            :placeholder="$t('public.text3')"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </div>
    </el-form>
    <div class="info-button">
      <DiluButton type="prev" @click="prev"></DiluButton>
      <DiluButton type="next" @click="next"></DiluButton>
    </div>
  </div>
</template>


<script>
import DiluButton from "../../../../components/pubilc/dilu-button.vue";
import { resetDate } from "../../../../utils/util/validate";
export default {
  data() {
    return {
      pickerOptions0: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 3600 * 1000 * 48;
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));

              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      pickerOptions: {
        disabledDate: (time) => {
          return (
            time.getTime() < this.ruleForm.serveStartTime ||
            time.getTime() < Date.now()
          );
        },
        shortcuts: [
          {
            text: this.$t("omission.text74"),
            onClick(picker) {
              let user = JSON.parse(localStorage.getItem("platformData"));

              if (user.region == "cn") {
                picker.$emit("pick", new Date());
              }
              if (user.region == "eur") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 7);
                picker.$emit("pick", date);
              }
              if (user.region == "usa") {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 13);
                picker.$emit("pick", date);
              }
              if (user.region == "jp") {
                const date = new Date();
                date.setTime(date.getTime() + 3600 * 1000 * 1);
                picker.$emit("pick", date);
              }
            },
          },
        ],
      },
      ruleForm: {
        appCode: "", //appCode
        platformProperty: 1, //平台方属性 公有 私有,0公有，1私有
        bikeCategoryId: [], //车辆类型id
        maxConnections: null, //车辆最大接入数，-1代表不限
        serveStartTime: "", //平台服务开始时间
        serveStopTime: "", //平台服务结束时间
      },
      appType: "",
      typeOptions: [],
      options: [],
      optionA: [],
      unlimited: false,
      rules: {
        appCode: [
          {
            required: true,
            message: this.$t("pages.operate.text55"),
            trigger: "blur",
          },
        ],
        platformProperty: {
          required: true,
          message: this.$t("pages.operate.text56"),
          trigger: "blur",
        },
        bikeCategoryId: [
          {
            type: "array",
            required: true,
            message: this.$t("pages.operate.text57"),
            trigger: "change",
          },
        ],
        maxConnections: {
          required: true,
          message: this.$t("pages.operate.text58"),
          trigger: "blur",
        },
        serveStartTime: [
          {
            required: true,
            message: this.$t("pages.operate.text59"),
            trigger: "change",
          },
        ],
        serveStopTime: [
          {
            required: true,
            message: this.$t("pages.operate.text60"),
            trigger: "change",
          },
        ],
      },
    };
  },
  watch: {
    activeName(newValue) {
      if (newValue == "ServicePermissions") {
        this.ruleForm = {
          appCode: this.params.appCode, //appCode
          platformProperty: this.params.platformProperty, //平台方属性 公有 私有,0公有，1私有
          bikeCategoryId: this.params.bikeCategoryId
            ? this.params.bikeCategoryId
            : [], //车辆类型id
          maxConnections: this.params.maxConnections, //车辆最大接入数，-1代表不限
          serveStartTime: this.params.serveStartTime, //平台服务开始时间
          serveStopTime: this.params.serveStopTime, //平台服务结束时间
        };
        if (this.params.maxConnections == -1) {
          this.unlimited = true;
        }
        if (this.params.platformProperty == 1) {
          for (let i in this.options) {
            if (this.options[i].appType == 10) {
              this.optionA.push(this.options[i]);
            }
          }
        } else {
          for (let i in this.options) {
            if (this.options[i].appType == 20) {
              this.optionA.push(this.options[i]);
              console.log(this.optionA);
            }
          }
        }
      }
    },
  },
  props: ["activeName", "params", "pageState"],
  components: {
    DiluButton,
  },
  mounted() {
    this.getAppCodes();
    this.bikeCategoryListAll();
  },
  methods: {
    appcodeChange(e) {
      this.ruleForm.appCode="";
      this.optionA = [];
      if (e == 1) {
        for (let i in this.options) {
          if (this.options[i].appType == 10) {
            this.optionA.push(this.options[i]);
            console.log(this.optionA);
          }
        }
      } else {
        for (let i in this.options) {
          if (this.options[i].appType == 20) {
            this.optionA.push(this.options[i]);
            console.log(this.optionA);
          }
        }
      }
    },
    startChange() {
      this.ruleForm.serveStopTime = null;
    },
    handleChange(e) {
      if (e < 0) {
        this.unlimited = true;
      } else {
        this.unlimited = false;
      }
    },
    maxConnectionsChange(e) {
      if (e) {
        this.ruleForm.maxConnections = -1;
      } else {
        this.ruleForm.maxConnections = 1;
      }
    },
    //获取appcode
    getAppCodes() {
      this.request.getAppCodes().then((res) => {
        this.options = res.data;
      });
    },
    //车辆类别-查询所有
    bikeCategoryListAll() {
      this.request.bikeCategoryListAll().then((res) => {
        this.typeOptions = res.data;
      });
    },
    next() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.unlimited) {
            this.ruleForm.maxConnections = -1;
          }
          this.ruleForm.serveStopTime = resetDate(this.ruleForm.serveStopTime); // 结束时间
          this.ruleForm.serveStartTime = resetDate(
            this.ruleForm.serveStartTime
          ); // 开始时间
          this.$emit("service", this.ruleForm);
        }
      });
    },
    prev() {
      this.$emit("prev");
    },
  },
};
</script>

<style scoped>
.inputs {
  width: 100%;
  display: flex;
  align-items: center;
}
.module-info {
  padding: 20px;
  box-sizing: border-box;
}
.inputs-checkout {
  margin-left: 20px;
  margin-bottom: 18px;
}
.info-button {
  margin: 40px 0;
  display: flex;
  justify-content: center;
}
</style>